import api from './api';

export const getStatistiquesComptables = async (params = {}) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

  const response = await api.get('/comptabilite/statistiques', { params: cleanedParams });
  return response.data;
};
